
/*
form is where we have all the details for all the inputs
for the entity  forms
each entity has their own form
*/
export const form   =  [

	{	
		name: "name", 
		value:'', 		
		id:'accounts_form_name',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "type", 
		value:'', 		
		id:'accounts_form_type',
		html:'',
		type:'multiselect',
		options :[
			{value: "bank", text: "Bank"},
			{value: "cash", text: "Cash"},
			{value: "other account receivable", text: "Other Account Receivable"},
			{value: "fixed asset", text: "Fixed Asset"},
			{value: "other asset", text: "Other Asset"},
			{value: "credit card payable", text: "Credit Card Payable"},
			{value: "loan", text: "Loan"},
			{value: "loan payable", text: "Loan Payable"},
			{value: "sales tax payable", text: "Sales Tax Payable"},
			{value: "other liability", text: "Other Liability"},
			{value: "owners equity", text: "Owner's Equity"},
			{value: "retained earnings", text: "Retained Earnings"},
			{value: "wholesale revenue", text: "Wholesale Revenue"},
			{value: "retail revenue", text: "Retail Revenue"},
			{value: "other income", text: "Other Income"},
			{value: "operating expenses", text: "Operating Expenses"},
			{value: "administrative expenses", text: "Administrative Expenses"},
			{value: "selling expenses", text: "Selling expenses"},
			{value: "interest expense", text: "Interest Expense"},
			{value: "other expenses", text: "Other Expenses"},
			{value: "asset", text: "Asset"},
			{value: "liabilitie", text: "Liability"},
			{value: "equity", text: "Equity"},
			{value: "revenue", text: "Revenue"},
			{value: "expense", text: "Expense"},
			{value: "expense-COGS", text: "Expense - COGS"},
		],
		required: true,  
	},
	{	
		name: "code", 
		value:'', 		
		id:'accounts_form_code',
		html:'',
		type:'textfield',
		required: false,  
	},
	{
		name: "active",
		value:'',
		id:'accounts_form_active',
		html:'',
		type:'checkbox',
		required: false,
	},
	{
		name: "bank_information_active",
		value:'',
		id:'accounts_form_bank_information_active',
		html:'',
		type:'checkbox',
		required: false,
	},
	{
		name: "account_holder_name",
		value:'',
		id:'accounts_form_account_holder_name',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "account_holder_address_1",
		value:'',
		id:'accounts_form_account_holder_address_1',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "account_holder_address_2",
		value:'',
		id:'accounts_form_account_holder_address_2',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "bank_name",
		value:'',
		id:'accounts_form_bank_name',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "bank_address_1",
		value:'',
		id:'accounts_form_bank_address_1',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "bank_address_2",
		value:'',
		id:'accounts_form_bank_address_2',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "account_number",
		value:'',
		id:'accounts_form_account_number',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "routing_number",
		value:'',
		id:'accounts_form_routing_number',
		html:'',
		type:'textfield',
		required: false,
	},
	{	
		name: "description", 
		value:'', 		
		id:'accounts_form_description',
		html:'',
		type:'textfield',
		required: false,  
	},
	// {	
	// 	name: "registered_date", 
	// 	value:'0000-00-00',
	// 	date: true, 		
	// 	id:'accounts_form_date',
	// 	html:'',
	// 	type:'textfield',
	// 	required: false,  
	// },
]



//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form)) 

